import {
    ASSIGN_PROCESSES_TO_SUPERVISOR_REQUEST,
    ASSIGN_PROCESSES_TO_SUPERVISOR_SUCCESS,
    ASSIGN_PROCESSES_TO_SUPERVISOR_FAIL,
    ASSIGN_PROCESSES_TO_SUPERVISOR_RESET,
    GET_SUPERVISOR_PROCESS_ASSIGNMENTS_REQUEST,
    GET_SUPERVISOR_PROCESS_ASSIGNMENTS_SUCCESS,
    GET_SUPERVISOR_PROCESS_ASSIGNMENTS_FAIL,
    GET_SUPERVISOR_PROCESS_ASSIGNMENTS_RESET,
    UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST,
    UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS,
    UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL,
    UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET,
    DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST,
    DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS,
    DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL,
    DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET,
} from '../constants/assignProcessConstants'

export const assignProcessesToSupervisorReducer = (state = {}, action) => {
    switch (action.type) {
        case ASSIGN_PROCESSES_TO_SUPERVISOR_REQUEST:
            return { loadingAssignProcesses: true }
        case ASSIGN_PROCESSES_TO_SUPERVISOR_SUCCESS:
            return {
                loadingAssignProcesses: false,
                assignProcessesData: action.payload,
            }
        case ASSIGN_PROCESSES_TO_SUPERVISOR_FAIL:
            return {
                loadingAssignProcesses: false,
                errorAssignProcesses: action.payload,
            }
        case ASSIGN_PROCESSES_TO_SUPERVISOR_RESET:
            return {}
        default:
            return state
    }
}

export const getSupervisorProcessAssignmentsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_SUPERVISOR_PROCESS_ASSIGNMENTS_REQUEST:
            return { loadingSupervisorProcessAssignments: true }
        case GET_SUPERVISOR_PROCESS_ASSIGNMENTS_SUCCESS:
            return {
                loadingSupervisorProcessAssignments: false,
                supervisorProcessAssignmentsData: action.payload,
            }
        case GET_SUPERVISOR_PROCESS_ASSIGNMENTS_FAIL:
            return {
                loadingSupervisorProcessAssignments: false,
                errorSupervisorProcessAssignments: action.payload,
            }
        case GET_SUPERVISOR_PROCESS_ASSIGNMENTS_RESET:
            return {}
        default:
            return state
    }
}

export const updateSupervisorProcessAssignmentReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST:
            return { loadingUpdateSupervisorProcessAssignment: true }
        case UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS:
            return {
                loadingUpdateSupervisorProcessAssignment: false,
                updateSupervisorProcessAssignmentData: action.payload,
            }
        case UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL:
            return {
                loadingUpdateSupervisorProcessAssignment: false,
                errorUpdateSupervisorProcessAssignment: action.payload,
            }
        case UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET:
            return {}
        default:
            return state
    }
}

export const deleteSupervisorProcessAssignmentReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST:
            return { loadingDeleteSupervisorProcessAssignment: true }
        case DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS:
            return {
                loadingDeleteSupervisorProcessAssignment: false,
                deleteSupervisorProcessAssignmentData: action.payload,
            }
        case DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL:
            return {
                loadingDeleteSupervisorProcessAssignment: false,
                errorDeleteSupervisorProcessAssignment: action.payload,
            }
        case DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET:
            return {}
        default:
            return state
    }
}